define('rebrush/system/layout/responsive-hub',[
    'lodash',
    'lucid',
    'json!shoptheme/etc/breakpoints.json',
    'enquire'
], function(
    _,
    lucidJS,
    BreakPoints,
    enquire
) {
    var _instance = null;
    var isMobile = true;

    function getInstance() {
        if (_instance === null) {
            _instance = new PubSubHub();
        }

        return _instance;
    };

    function PubSubHub() {
        if (!(this instanceof PubSubHub)) {
            return getInstance();
        }

        lucidJS.EventEmitter.call(this);

        this._register = {};
    }

    PubSubHub.getInstance = getInstance;

    PubSubHub.prototype = _.create(new lucidJS.EventEmitter, {
        'constructor': PubSubHub,
        'isMobile': function() {
            return isMobile;
        }
    });

    enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
        match: function() {
            var instance = getInstance();
            isMobile = false;

            instance.unflag('change.mobile.enter');
            instance.flag('change.mobile.leave');
        },
        unmatch: function() {
            var instance = getInstance();
            isMobile = true;

            instance.unflag('change.mobile.leave');
            instance.flag('change.mobile.enter');
        }
    }, true);

    return PubSubHub.getInstance();
});
